import { useLocation } from "react-router";
import LoginForm from "../components/Login/LoginForm"
import { NavLink } from "react-router";
import { useTrads } from "../contexts/trads/useTrads";
import "./LoginForm.scss"
import type { LocationState } from "../types/QueryParameters";
function LoginPage (){
    const location = useLocation();
    const state = location.state as LocationState | undefined;
    const {translate}=useTrads();
    return (
        <div className="login-form">
            <h4 ><a href="/"><img src="/assets/logo-tiny.png" width="50" height="50" alt="push asso" /></a></h4>
            <LoginForm state={state} />
            <div className="d-flex justify-content-between w-50">
                <NavLink to='/lost'>{translate('link_text_lost')}</NavLink>
                <NavLink to='/register'>{translate('link_text_register')}</NavLink>
            </div>
        </div>
    )
}

export default LoginPage;